import DetailArchive from './Main'

const route = {
  path: '/archive/:id',
  name: 'archive-detail',
  component: DetailArchive
}

export default route
